import type {Meta, StoryObj} from "@storybook/web-components";
import type {NotificationCenter} from "../../src/components/notification-center/notification-center";
import {html} from "lit";

const meta: Meta<NotificationCenter> = {
	title: "Notification/Notification Center",
	component: "uxn-notification-center",

	decorators: [
		(story, {args}) =>
			html` <fragment>
				<ux-u-silent-auth
					issuer="https://identity-s.trumpf.com"
					client-id="zyffE9ozijzUpQqdaOyteGMJfhMa"
					client-name="notificationmanagement"
					scope="openid"
					debug="true"
				></ux-u-silent-auth>
				<div style="height: 50vh; background-color: lightgray">
					<a data-name="notifications">
						<uxn-notification-bell env="${args.env}"></uxn-notification-bell>
						<span class="ux-iws-navigation-meta__link-text">Notifications</span>
					</a>
					<ux-tooltip tooltip-target="a[data-name='notifications']" data-id="tooltip-navi-notifications" align="top"> ${story()} </ux-tooltip>
				</div>
			</fragment>`,
	],

	render: ({
		notificationsCenterUrl, //! seems to be dead
		notificationCenterTarget, //! seems to be dead
		notificationSettingsUrl,
		notificationSettingsTarget,
		settingsDisabled,
		locale,
		version,
		env,
		debug,
	}) => html`
		<uxn-notification-center
			notifications-center-url="${notificationsCenterUrl}"
			notification-center-target="${notificationCenterTarget}"
			notification-settings-url="${notificationSettingsUrl}"
			notification-settings-target="${notificationSettingsTarget}"
			settings-disabled="${settingsDisabled}"
			locale="${locale}"
			version="${version}"
			env="${env}"
			debug="${debug}"
		></uxn-notification-center>
	`,

	argTypes: {
		notificationsCenterUrl: {control: "text"},
		notificationCenterTarget: {control: "text"},
		notificationSettingsUrl: {control: "text"},
		notificationSettingsTarget: {control: "text"},
		settingsDisabled: {control: "boolean"},
		locale: {control: "text"},
		version: {control: "select", options: ["2.0", "1.0"]}, //! are those really the available variants?
		env: {control: "select", options: ["prod", "qa", "dev"]}, //! are those really the available variants?
		debug: {control: "boolean"},
	},
};

export default meta;
type Story = StoryObj<NotificationCenter>;

export const Default: Story = {
	args: {
		notificationsCenterUrl: "",
		notificationCenterTarget: "",
		notificationSettingsUrl: "https://example.com/notification-settings",
		notificationSettingsTarget: "_blank",
		settingsDisabled: false,
		locale: "en_INT",
		version: "2.0",
		env: "qa",
		debug: true,
	},
	parameters: {
		controls: {exclude: ["el", "retry", "settingsURL"]},
	},
};
